/* ============
 * Actions for the cvc module
 * ============
 *
 * The actions that are available on the
 * cvc module.
 */
import axios from 'axios'

export default {
  registerCVC ({ dispatch }, item) {
    let api = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(api + 'payment-method-changes/registrations', item)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  async getIP () {
    let api = process.env.GET_IP
    return new Promise((resolve, reject) => {
      axios.get(api)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getPaymentCardsByClient ({ dispatch }, item) {
    let api = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(api + 'payments/cards', item)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  // Delegado en la sesión de CR Auth (user/ensureSession); nunca rechaza, igual que antes
  checkJWT ({ dispatch }) {
    return dispatch('user/checkJWT', null, { root: true })
  },
  sendMailCVC ({ dispatch }, item) {
    let api = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(api + 'users/payment-method-changes/emails', item)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/cvc/actions.js